import React from 'react';
interface PriceDisplayProps {
  amount?: number;
  className?: string;
}
export function PriceDisplay({
  amount = 9000,
  className = ''
}: PriceDisplayProps) {
  const formattedNumber = amount.toLocaleString('es-AR');
  return <span className={className} data-id="element-222">
      ${formattedNumber}
    </span>;
}